import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { ShippingOrder } from '../../DeShippingTableWrapper';

// Assignment status template with visual indicators
export const OrderAssignmentStatusTemplate = (rowData: ShippingOrder, onClick?: (order: ShippingOrder) => void) => {
  const { assigned_items, total_items } = rowData;
  
  let statusClass = '';
  let icon = '';
  let text = '';
  let tooltipText = '';

  if (assigned_items === total_items) {
    // Fully Assigned
    statusClass = 'text-success';
    icon = '✅';
    text = `${assigned_items}/${total_items} items assigned`;
    tooltipText = 'All items in this order have been assigned to stores';
  } else if (assigned_items > 0) {
    // Partially Assigned
    statusClass = 'text-warning';
    icon = '⚠️';
    text = `${assigned_items}/${total_items} items assigned`;
    tooltipText = 'Some items are assigned, others still need assignment. Click to assign remaining items.';
  } else {
    // Unassigned
    statusClass = 'text-danger';
    icon = '❌';
    text = `0/${total_items} items assigned`;
    tooltipText = 'No items in this order have been assigned yet. Click to assign items.';
  }

  const handleClick = () => {
    if (onClick) {
      onClick(rowData);
    }
  };

  return (
    <span 
      className={`assignment-status ${statusClass}`}
      data-pr-tooltip={tooltipText}
      data-pr-position="left"
      data-testid={`assignment-status-${rowData.order_id}`}
      onClick={handleClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <span className="me-2">{icon}</span>
      {text}
      <Tooltip target=".assignment-status" />
    </span>
  );
};